import { capitalize } from "helpers/utils/utils_general";
import i18n from "i18n";

const data = {
  initialOrder: {
    origin: "",
    destination: "",
    type: "REL",
  },
  headerOptions: [],
  steps: [
    {
      id: "0",
      name: capitalize(i18n.t("origin")),
    },
    {
      id: "1",
      name: i18n.t("products"),
    },
    {
      id: "2",
      name: capitalize(i18n.t("destination")),
    },
    {
      id: "3",
      name: i18n.t("confirmation"),
    },
  ],
};

export default data;
